import type { FC } from "react";

import styles from "./ProductCardColors.module.scss";

export type ProductCardColorsProps = {
  colors?: string[];
};

const PREVIEWED_COLORS_COUNT = 3;

export const ProductCardColors: FC<ProductCardColorsProps> = ({ colors = [] }) => {
  const numberOfColors = colors.length;
  const colorsToDisplay = colors.slice(0, PREVIEWED_COLORS_COUNT);
  return (
    <ul className={styles.colorsList}>
      {colorsToDisplay.map((color, index) => (
        <li
          key={index}
          className={styles.colorsListItem}
          data-testid="productCardColor"
          style={{ backgroundColor: color }}
        />
      ))}
      {numberOfColors > PREVIEWED_COLORS_COUNT && <li>+{numberOfColors - PREVIEWED_COLORS_COUNT}</li>}
    </ul>
  );
};
